import { gql, type TypedDocumentNode } from "@apollo/client";

export type CareerServicesModeStat = {
  mode: string;
  count: number;
};

export type CareerServicesCategoryStat = {
  category: string;
  count: number;
};

export type CareerServicesDayMode = {
  mode: string;
  count: number;
};

export type CareerServicesDay = {
  date: string;
  total: number;
  modes: CareerServicesDayMode[];
};

export type CareerServicesRecentInteraction = {
  id: string;
  interactionDate: string;
  mode: string;
  categories: string[];
  ownerName: string | null;
  personPgaId: string | null;
};

export type CareerServicesOwnerStat = {
  ownerId: string | null;
  ownerName: string | null;
  interactions: number;
  topMode: string | null;
  topCategories: string[];
};

export type CareerServicesInteractionStats = {
  totalInteractions: number;
  byMode: CareerServicesModeStat[];
  categories: CareerServicesCategoryStat[];
  days: CareerServicesDay[];
  owners: CareerServicesOwnerStat[];
  recentInteractions: CareerServicesRecentInteraction[];
};

export type CareerServicesInteractionStatsResponse = {
  careerServicesInteractionStats: CareerServicesInteractionStats | null;
};

export type CareerServicesInteractionStatsVariables = {
  startDateTime: string;
  endDateTime: string;
  ownerId?: string | null;
};

export const CAREER_SERVICES_INTERACTION_STATS_QUERY: TypedDocumentNode<
  CareerServicesInteractionStatsResponse,
  CareerServicesInteractionStatsVariables
> = gql`
  query CareerServicesInteractionStats($startDateTime: ISO8601DateTime!, $endDateTime: ISO8601DateTime!, $ownerId: ID) {
    careerServicesInteractionStats(startDateTime: $startDateTime, endDateTime: $endDateTime, ownerId: $ownerId) {
      totalInteractions
      byMode {
        mode
        count
      }
      categories {
        category
        count
      }
      days {
        date
        total
        modes {
          mode
          count
        }
      }
      recentInteractions {
        id
        interactionDate
        mode
        categories
        ownerName
        personPgaId
      }
      owners {
        ownerId
        ownerName
        interactions
        topMode
        topCategories
      }
    }
  }
`;

export type CareerServicesInteractionHighlights = {
  bullets: string[];
  generatedAt: string | null;
};

export type CareerServicesInteractionHighlightsResponse = {
  careerServicesInteractionHighlights: CareerServicesInteractionHighlights | null;
};

export type CareerServicesInteractionHighlightsVariables = {
  startDateTime: string;
  endDateTime: string;
  categories?: string[] | null;
  mode?: string | null;
  ownerId?: string | null;
};

export const CAREER_SERVICES_INTERACTION_HIGHLIGHTS_QUERY: TypedDocumentNode<
  CareerServicesInteractionHighlightsResponse,
  CareerServicesInteractionHighlightsVariables
> = gql`
  query CareerServicesInteractionHighlights(
    $startDateTime: ISO8601DateTime!
    $endDateTime: ISO8601DateTime!
    $categories: [String!]
    $mode: String
    $ownerId: ID
  ) {
    careerServicesInteractionHighlights(
      startDateTime: $startDateTime
      endDateTime: $endDateTime
      categories: $categories
      mode: $mode
      ownerId: $ownerId
    ) {
      bullets
      generatedAt
    }
  }
`;
